import * as React from 'react';
import cx from 'classnames';
import MoCommonTop from '@src/ui-components/mo-common-top';

const styles = require('./index.less');

/** 玩家标签最多展示三个，避免接口返回的长标签列表把卷轴报告区撑爆。 */
const REPORT_TAG_LIMIT = 3;

/** 报告行为"左标题 + 右数据"的行结构，替代原 psd 两列绝对定位的错位排版。 */
function createReportRows(viewModel) {
  return [
    { id: 'score', label: '剑侠评分：', value: viewModel.jianxiaScoreText },
    { id: 'former-name', label: '曾经用名：', value: viewModel.formerRoleNameText },
    { id: 'registered', label: '账号注册：', value: viewModel.firstLoginDateText },
    { id: 'menpai', label: '羁绊门派：', value: viewModel.roleIdentityText },
    { id: 'tags', label: '玩家标签：', tags: (viewModel.tags || []).slice(0, REPORT_TAG_LIMIT) }
  ];
}

function renderReportValue(row, viewModel) {
  if (row.id !== 'tags') return row.value;
  const rarities = viewModel.tagRarities || {};
  return row.tags.map((tag, index) => (
    <React.Fragment key={tag}>
      {index > 0 && <span className={styles.tagSeparator}>&#32;&#32;/&#32;&#32;</span>}
      <span className={styles[`reportTagR${rarities[tag] || 1}`]}>{tag}</span>
    </React.Fragment>
  ));
}

const MoVeteranReviewSummary = ({ className, viewModel = {}, teamState = {}, onPosterAction, onBack }) => {
  const hasTeam = teamState.hasTeam === true;
  const posterActionDisabled = teamState.status === 'loading';
  const handlePosterAction = () => {
    if (!posterActionDisabled && onPosterAction) {
      onPosterAction();
    }
  };

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.layer1} data-name="回顾总结页面 - 背景" />
      {/* 左上角返回（2026-09-23 需求）：视觉对齐 team 页 BackHomeLink（&lt;返回），
          点击回退到回顾首页（页内 stage 切换，非路由跳转） */}
      <button className={cx(styles.backEntry, styles.action)} data-name="返回回顾首页" data-role="back-to-review-home" onClick={onBack} type="button">
        {'<返回'}
      </button>
      <div className={styles.group1} data-name="回顾总结页面 - 内容">
        {/* 名帖分享奖励：标题图 + 四张完整奖励框图（文案已烘进图素，无需逐层拼装） */}
        <div className={cx(styles.group2, styles.staggerRewards)} data-name="回顾总结页 - 名帖分享奖励">
          <div className={styles.layer6} data-name="名帖分享奖励-标题" />
          <div className={styles.group3} data-name="奖励">
            <div className={cx(styles.rewardFrame, styles.rewardFrameCoin)} data-name="元宝奖励框" />
            <div className={cx(styles.rewardFrame, styles.rewardFrameCrystal)} data-name="青晶奖励框" />
            <div className={cx(styles.rewardFrame, styles.rewardFramePowder)} data-name="五维散奖励框" />
            <div className={cx(styles.rewardFrame, styles.rewardFrameOrnament)} data-name="腰饰奖励框" />
          </div>
        </div>

        <div className={cx(styles.group4, styles.staggerReport)} data-name="回顾总结页 - 报告主体">
          <div className={styles.group5} data-name="报告奖励提示文案">
            <div
              className={styles.layer7}
              aria-label="点击上述按钮，生成专属江湖名帖保存分享。奖励将自动发放至我的背包处。"
              data-name="点击上述按钮，生成专属江湖名帖保存分享。 奖励将自动发放至“我的背包”处。"
            />
          </div>

          <div className={styles.group6} data-name="报告按钮区">
            {hasTeam ? (
              <button
                className={cx(styles.layer8, styles.action, styles.visibleAction)}
                data-name="有队伍态-邀请好友"
                disabled={posterActionDisabled}
                onClick={handlePosterAction}
                type="button"
              />
            ) : (
              <div className={styles.layer8} data-name="有队伍态-邀请好友" aria-hidden="true" />
            )}
            {!hasTeam ? (
              <button
                className={cx(styles.layer9, styles.action)}
                data-name="无队伍态-生成海报(名帖)"
                disabled={posterActionDisabled}
                onClick={handlePosterAction}
                type="button"
              />
            ) : (
              <div className={cx(styles.layer9, styles.hiddenAction)} data-name="无队伍态-生成海报(名帖)" aria-hidden="true" />
            )}
          </div>

          <div className={styles.group7} data-name="报告展示区">
            <div className={styles.layer10} data-name="卷轴背景" />
            <div className={styles.group8} data-name="报告展示">
              <div className={styles.group9} data-name="报告展示内容">
                {createReportRows(viewModel).map(row => (
                  <div className={styles.reportRow} data-role="report-row" key={row.id}>
                    <span className={styles.reportLabel}>{row.label}</span>
                    <span className={styles.reportValue}>{renderReportValue(row, viewModel)}</span>
                  </div>
                ))}
              </div>

              <div className={styles.layer14} data-name="报告展示标题" />
            </div>
          </div>
        </div>

        <div className={cx(styles.layer15, styles.staggerTitle)} data-name="回顾总结页面 - 标题" />
      </div>

      <MoCommonTop />
    </div>
  );
};

export default MoVeteranReviewSummary;
